const PARTNERS = {
  SITELIO: { id: 2, name: 'Sitelio' },
  WEBSITEBUILDER: { id: 3, name: 'WebsiteBuilder' },
  SITEY: { id: 5, name: 'Sitey' },
  SITEBUILDER: { id: 6, name: 'SiteBuilder' },
  EHOST: { id: 7, name: 'eHost' },
  HOSTCLEAR: { id: 8, name: 'HostClear' },
  IDEAHOST: { id: 9, name: 'IdeaHost' },
  CLOUDHOSTED: { id: 11, name: 'CloudHosted' },
  DIGITALCLOUD: { id: 12, name: 'Digital Cloud' },
  HOSTFINITY: { id: 13, name: 'Hostfinity' },
  TEMPLATESITES: { id: 14, name: 'TemplateSites' },
  SITEBLOG: { id: 15, name: 'SiteBlog' },
  WEBSITETAILOR: { id: 16, name: 'Website Tailor' },
  GATOR: { id: 40, name: 'Gator' },
  CTCTBUILDER: { id: 50, name: 'CTCT Builder' },
  CREATIVEMAIL: { id: 60, name: 'Creative Mail' },
  ECOMDASH: { id: 80, name: 'Ecomdash' },
  BLUEHOST: { id: 101, name: 'Bluehost' },
  DOMAINCOM: { id: 108, name: 'Domain.com' },
  BIGROCK: { id: 151, name: 'BigRock' }
}
export default PARTNERS
